/**
 * TutorSettingsScreen — les paramètres du tuteur (route `settings`), à la place de
 * `student/account/SettingsTabNavigator.js` pour un tuteur dont l'espace est allumé.
 *
 * Une route, quatre pages : la liste (`<TutorSettingsPage>`), Général (`<TutorSettingsGeneralPage>`),
 * Adresse et Réglages (les pages de l'élève : ce sont les mêmes écrans aujourd'hui). « Profil » ouvre
 * « Compléter mon profil », « Fuseau horaire » l'écran commun. Patron A : les valeurs du compte
 * (`tutorSettingsViewModel`), recouvertes par les brouillons et enregistrées par
 * `useTutorSettingsState`.
 */
import React from "react"
import { useSelector } from "react-redux"

import { StudentSettingsAddressPage, StudentSettingsPreferencesPage } from "../../../../../../design-system/student"
import { TutorSettingsGeneralPage, TutorSettingsPage } from "../../../../../../design-system/tutor"
import { tutorSettingsViewModel } from "../../../../view-models/tutor/Account/tutorSettingsViewModel"
import { type TutorSpaceScreenProps } from "../tutorSpaceRouteTypes"
import { useTutorSettingsState, useTutorSettingsUi } from "./useTutorSettingsState"

export function TutorSettingsScreen(props: TutorSpaceScreenProps) {
    const [ui, dispatchUi] = useTutorSettingsUi(props.route?.params?.initialTab)
    const vm = useSelector((state: unknown) => tutorSettingsViewModel(state, ui.drafts.preferences))
    const pages = useTutorSettingsState(vm, ui, dispatchUi)

    switch (pages.view) {
        case "general":
            return <TutorSettingsGeneralPage {...pages.general} />
        case "address":
            return <StudentSettingsAddressPage {...pages.address} />
        case "preferences":
            return <StudentSettingsPreferencesPage {...pages.preferences} />
        default:
            return <TutorSettingsPage {...pages.hub} />
    }
}
